const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const {atSingleClass} = require("../core/vault/StateCursors");
const AT = require("../core/vault/ActionTypes");

const withOfficeErrorCatching = require("../core/hoc/withOfficeErrorCatching");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const LoadGuard = require("../core/view/LoadGuard");
const LoadState = require("../core/vault/util/LoadState");
const ClassesUtil = require("./util/ClassesUtil");
const AssetsUtil = require("../core/util/AssetsUtil");

const styles = require("./styles/PageClassCards.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withOfficeErrorCatching(Component);
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => {
			return {
				singleClass: atSingleClass(vaultState).get() || LoadState.loadInit(),
			};
		},
		{forLoggedIn: true}
	);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "PageClassCards",

		propTypes: {
			classID: PT.number.isRequired,
			instructions: PT.string,

			// Injected by HOCs
			singleClass: PT.object.isRequired,
			dispatch: PT.func.isRequired,
		},

		loadStudents: function() {
			this.props.dispatch({
				type: AT.LOAD_SINGLE_CLASS_REQUEST,
				classID: this.props.classID,
			});
		},

		renderMain: function() {
			const students = this.props.singleClass.students;
			const sortedStudents = _.sortBy(students, s =>
				ClassesUtil.getStudentName(s)
			);
			return _.map(sortedStudents, s => {
				const displayName = ClassesUtil.getStudentName(s);
				return (
					<div className={styles.student} key={s.id}>
						<img src={AssetsUtil.getLogo("aops-ba")} className={styles.logo} />
						<div className={styles.item}>
							<b>Name: </b>
							{displayName}
						</div>
						<div className={styles.item}>
							<b>Username: </b>
							{s.schoolLogin || s.username}
						</div>
						<div className={styles.instructions}>{this.props.instructions}</div>
					</div>
				);
			});
		},

		render: function() {
			return (
				<div className={styles.main}>
					<LoadGuard
						identifier="singleClass"
						status={this.props.singleClass}
						requestLoad={this.loadStudents}
						loadingView="logo"
						logoColorType="color"
						errorView="refreshOffice"
						renderLoaded={this.renderMain}
					/>
				</div>
			);
		},
	})
);
